export default __webpack_public_path__ + "static/icon-8-2-7018075735249f191a4a3c58e61311ab.png";